export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `DateTime` scalar represents an ISO-8601 compliant date time type. */
  DateTime: { input: any; output: any; }
  UUID: { input: any; output: any; }
};

/** Represents a new Jeopardy game. */
export type AddJeopardyGameInput = {
  advancedMode: Scalars['Boolean']['input'];
  langue?: InputMaybe<Scalars['String']['input']>;
  multiplayer: Scalars['Boolean']['input'];
  players: Scalars['Int']['input'];
  private: Scalars['Boolean']['input'];
  roomName?: InputMaybe<Scalars['String']['input']>;
};

/** Represents the answer results of a question */
export type AddJeopardyUserAnswerInput = {
  roundId?: InputMaybe<Scalars['Int']['input']>;
  selectedAnswerIndex?: InputMaybe<Scalars['Int']['input']>;
  skip: Scalars['Boolean']['input'];
  trueAnswerIndex: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};

export type BooleanOperationFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  neq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DateTimeOperationFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  neq?: InputMaybe<Scalars['DateTime']['input']>;
  ngt?: InputMaybe<Scalars['DateTime']['input']>;
  ngte?: InputMaybe<Scalars['DateTime']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  nlt?: InputMaybe<Scalars['DateTime']['input']>;
  nlte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type IntOperationFilterInput = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  neq?: InputMaybe<Scalars['Int']['input']>;
  ngt?: InputMaybe<Scalars['Int']['input']>;
  ngte?: InputMaybe<Scalars['Int']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  nlt?: InputMaybe<Scalars['Int']['input']>;
  nlte?: InputMaybe<Scalars['Int']['input']>;
};

export type JeopardyApiCoreError = {
  __typename?: 'JeopardyApiCoreError';
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type JeopardyApiCoreWarning = {
  __typename?: 'JeopardyApiCoreWarning';
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type JeopardyGame = {
  __typename?: 'JeopardyGame';
  active: Scalars['Boolean']['output'];
  advancedMode: Scalars['Boolean']['output'];
  createdOn?: Maybe<Scalars['DateTime']['output']>;
  endDateTime?: Maybe<Scalars['DateTime']['output']>;
  gameEngine?: Maybe<JeopardyGameEngine>;
  gameEngineId: Scalars['Int']['output'];
  gameId: Scalars['Int']['output'];
  jeopardyQuestions?: Maybe<Array<Maybe<JeopardyQuestion>>>;
  jeopardyRounds?: Maybe<Array<Maybe<JeopardyRound>>>;
  jeopardyUsers?: Maybe<Array<Maybe<JeopardyUser>>>;
  multiplayer: Scalars['Boolean']['output'];
  players: Scalars['Int']['output'];
  private: Scalars['Boolean']['output'];
  questions: Scalars['Int']['output'];
  roomCode?: Maybe<Scalars['String']['output']>;
  roomName?: Maybe<Scalars['String']['output']>;
  startDateTime?: Maybe<Scalars['DateTime']['output']>;
};

export type JeopardyGameEngine = {
  __typename?: 'JeopardyGameEngine';
  activation?: Maybe<Scalars['Boolean']['output']>;
  gameEngineId: Scalars['Int']['output'];
  jeopardyGames?: Maybe<Array<Maybe<JeopardyGame>>>;
  settingDefaultScore?: Maybe<Scalars['Int']['output']>;
  settingInactivityDetection?: Maybe<Scalars['Int']['output']>;
  settingInactivityDetectionNotification?: Maybe<Scalars['Int']['output']>;
  settingJeopardy1Player?: Maybe<Scalars['Int']['output']>;
  settingJeopardy2Players?: Maybe<Scalars['Int']['output']>;
  settingJeopardy3Players?: Maybe<Scalars['Int']['output']>;
  settingJeopardy4Players?: Maybe<Scalars['Int']['output']>;
  settingJoker5050?: Maybe<Scalars['Int']['output']>;
  settingJokerSkip?: Maybe<Scalars['Int']['output']>;
  settingPassivePlayerFalseAnswerRewardPercentage?: Maybe<Scalars['Int']['output']>;
  settingPassivePlayerGoodAnswerRewardPercentage?: Maybe<Scalars['Int']['output']>;
  settingTimer100Points?: Maybe<Scalars['Int']['output']>;
  settingTimer200Points?: Maybe<Scalars['Int']['output']>;
  settingTimer300Points?: Maybe<Scalars['Int']['output']>;
  settingTimer400Points?: Maybe<Scalars['Int']['output']>;
  settingTimer500Points?: Maybe<Scalars['Int']['output']>;
  settingTimerDifficultyLevel?: Maybe<Scalars['Int']['output']>;
  settingTimerForInactivityDetection?: Maybe<Scalars['Int']['output']>;
  settingTimerJoinRoom?: Maybe<Scalars['Int']['output']>;
  settingTopHighestScores?: Maybe<Scalars['Int']['output']>;
  timestamp?: Maybe<Scalars['DateTime']['output']>;
  umbracoUser?: Maybe<Scalars['String']['output']>;
};

export type JeopardyGameEngineFilterInput = {
  activation?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<JeopardyGameEngineFilterInput>>;
  gameEngineId?: InputMaybe<IntOperationFilterInput>;
  jeopardyGames?: InputMaybe<ListFilterInputTypeOfJeopardyGameFilterInput>;
  or?: InputMaybe<Array<JeopardyGameEngineFilterInput>>;
  settingDefaultScore?: InputMaybe<IntOperationFilterInput>;
  settingInactivityDetection?: InputMaybe<IntOperationFilterInput>;
  settingInactivityDetectionNotification?: InputMaybe<IntOperationFilterInput>;
  settingJeopardy1Player?: InputMaybe<IntOperationFilterInput>;
  settingJeopardy2Players?: InputMaybe<IntOperationFilterInput>;
  settingJeopardy3Players?: InputMaybe<IntOperationFilterInput>;
  settingJeopardy4Players?: InputMaybe<IntOperationFilterInput>;
  settingJoker5050?: InputMaybe<IntOperationFilterInput>;
  settingJokerSkip?: InputMaybe<IntOperationFilterInput>;
  settingPassivePlayerFalseAnswerRewardPercentage?: InputMaybe<IntOperationFilterInput>;
  settingPassivePlayerGoodAnswerRewardPercentage?: InputMaybe<IntOperationFilterInput>;
  settingTimer100Points?: InputMaybe<IntOperationFilterInput>;
  settingTimer200Points?: InputMaybe<IntOperationFilterInput>;
  settingTimer300Points?: InputMaybe<IntOperationFilterInput>;
  settingTimer400Points?: InputMaybe<IntOperationFilterInput>;
  settingTimer500Points?: InputMaybe<IntOperationFilterInput>;
  settingTimerDifficultyLevel?: InputMaybe<IntOperationFilterInput>;
  settingTimerForInactivityDetection?: InputMaybe<IntOperationFilterInput>;
  settingTimerJoinRoom?: InputMaybe<IntOperationFilterInput>;
  settingTopHighestScores?: InputMaybe<IntOperationFilterInput>;
  timestamp?: InputMaybe<DateTimeOperationFilterInput>;
  umbracoUser?: InputMaybe<StringOperationFilterInput>;
};

export type JeopardyGameEngineSortInput = {
  activation?: InputMaybe<SortEnumType>;
  gameEngineId?: InputMaybe<SortEnumType>;
  settingDefaultScore?: InputMaybe<SortEnumType>;
  settingInactivityDetection?: InputMaybe<SortEnumType>;
  settingInactivityDetectionNotification?: InputMaybe<SortEnumType>;
  settingJeopardy1Player?: InputMaybe<SortEnumType>;
  settingJeopardy2Players?: InputMaybe<SortEnumType>;
  settingJeopardy3Players?: InputMaybe<SortEnumType>;
  settingJeopardy4Players?: InputMaybe<SortEnumType>;
  settingJoker5050?: InputMaybe<SortEnumType>;
  settingJokerSkip?: InputMaybe<SortEnumType>;
  settingPassivePlayerFalseAnswerRewardPercentage?: InputMaybe<SortEnumType>;
  settingPassivePlayerGoodAnswerRewardPercentage?: InputMaybe<SortEnumType>;
  settingTimer100Points?: InputMaybe<SortEnumType>;
  settingTimer200Points?: InputMaybe<SortEnumType>;
  settingTimer300Points?: InputMaybe<SortEnumType>;
  settingTimer400Points?: InputMaybe<SortEnumType>;
  settingTimer500Points?: InputMaybe<SortEnumType>;
  settingTimerDifficultyLevel?: InputMaybe<SortEnumType>;
  settingTimerForInactivityDetection?: InputMaybe<SortEnumType>;
  settingTimerJoinRoom?: InputMaybe<SortEnumType>;
  settingTopHighestScores?: InputMaybe<SortEnumType>;
  timestamp?: InputMaybe<SortEnumType>;
  umbracoUser?: InputMaybe<SortEnumType>;
};

export type JeopardyGameFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  advancedMode?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<JeopardyGameFilterInput>>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  endDateTime?: InputMaybe<DateTimeOperationFilterInput>;
  gameEngine?: InputMaybe<JeopardyGameEngineFilterInput>;
  gameEngineId?: InputMaybe<IntOperationFilterInput>;
  gameId?: InputMaybe<IntOperationFilterInput>;
  jeopardyQuestions?: InputMaybe<ListFilterInputTypeOfJeopardyQuestionFilterInput>;
  jeopardyRounds?: InputMaybe<ListFilterInputTypeOfJeopardyRoundFilterInput>;
  jeopardyUsers?: InputMaybe<ListFilterInputTypeOfJeopardyUserFilterInput>;
  multiplayer?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<JeopardyGameFilterInput>>;
  players?: InputMaybe<IntOperationFilterInput>;
  private?: InputMaybe<BooleanOperationFilterInput>;
  questions?: InputMaybe<IntOperationFilterInput>;
  roomCode?: InputMaybe<StringOperationFilterInput>;
  roomName?: InputMaybe<StringOperationFilterInput>;
  startDateTime?: InputMaybe<DateTimeOperationFilterInput>;
};

export type JeopardyGameSortInput = {
  active?: InputMaybe<SortEnumType>;
  advancedMode?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  endDateTime?: InputMaybe<SortEnumType>;
  gameEngine?: InputMaybe<JeopardyGameEngineSortInput>;
  gameEngineId?: InputMaybe<SortEnumType>;
  gameId?: InputMaybe<SortEnumType>;
  multiplayer?: InputMaybe<SortEnumType>;
  players?: InputMaybe<SortEnumType>;
  private?: InputMaybe<SortEnumType>;
  questions?: InputMaybe<SortEnumType>;
  roomCode?: InputMaybe<SortEnumType>;
  roomName?: InputMaybe<SortEnumType>;
  startDateTime?: InputMaybe<SortEnumType>;
};

export type JeopardyQuestion = {
  __typename?: 'JeopardyQuestion';
  active: Scalars['Boolean']['output'];
  createdOn?: Maybe<Scalars['DateTime']['output']>;
  game?: Maybe<JeopardyGame>;
  gameId: Scalars['Int']['output'];
  jeopardyRounds?: Maybe<Array<Maybe<JeopardyRound>>>;
  points: Scalars['Int']['output'];
  questionId: Scalars['Int']['output'];
  timer: Scalars['Int']['output'];
  topicId: Scalars['UUID']['output'];
  umbracoQuestionId: Scalars['UUID']['output'];
};

export type JeopardyQuestionFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<JeopardyQuestionFilterInput>>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  game?: InputMaybe<JeopardyGameFilterInput>;
  gameId?: InputMaybe<IntOperationFilterInput>;
  jeopardyRounds?: InputMaybe<ListFilterInputTypeOfJeopardyRoundFilterInput>;
  or?: InputMaybe<Array<JeopardyQuestionFilterInput>>;
  points?: InputMaybe<IntOperationFilterInput>;
  questionId?: InputMaybe<IntOperationFilterInput>;
  timer?: InputMaybe<IntOperationFilterInput>;
  topicId?: InputMaybe<UuidOperationFilterInput>;
  umbracoQuestionId?: InputMaybe<UuidOperationFilterInput>;
};

export type JeopardyQuestionSortInput = {
  active?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  game?: InputMaybe<JeopardyGameSortInput>;
  gameId?: InputMaybe<SortEnumType>;
  points?: InputMaybe<SortEnumType>;
  questionId?: InputMaybe<SortEnumType>;
  timer?: InputMaybe<SortEnumType>;
  topicId?: InputMaybe<SortEnumType>;
  umbracoQuestionId?: InputMaybe<SortEnumType>;
};

export type JeopardyRoom = {
  __typename?: 'JeopardyRoom';
  countryId: Scalars['String']['output'];
  roomId: Scalars['Int']['output'];
  roomName: Scalars['String']['output'];
};

export type JeopardyRoomFilterInput = {
  and?: InputMaybe<Array<JeopardyRoomFilterInput>>;
  countryId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<JeopardyRoomFilterInput>>;
  roomId?: InputMaybe<IntOperationFilterInput>;
  roomName?: InputMaybe<StringOperationFilterInput>;
};

export type JeopardyRoomSortInput = {
  countryId?: InputMaybe<SortEnumType>;
  roomId?: InputMaybe<SortEnumType>;
  roomName?: InputMaybe<SortEnumType>;
};

export type JeopardyRound = {
  __typename?: 'JeopardyRound';
  activeUser?: Maybe<JeopardyUser>;
  activeUserId: Scalars['Int']['output'];
  createdOn?: Maybe<Scalars['DateTime']['output']>;
  game?: Maybe<JeopardyGame>;
  gameId: Scalars['Int']['output'];
  jeopardyUserAnswers?: Maybe<Array<Maybe<JeopardyUserAnswer>>>;
  question?: Maybe<JeopardyQuestion>;
  questionId?: Maybe<Scalars['Int']['output']>;
  remainingAnswerTime?: Maybe<Scalars['Int']['output']>;
  roundId: Scalars['Int']['output'];
  roundNumber: Scalars['Int']['output'];
  timeEnd?: Maybe<Scalars['DateTime']['output']>;
  timeStart?: Maybe<Scalars['DateTime']['output']>;
};

export type JeopardyRoundFilterInput = {
  activeUser?: InputMaybe<JeopardyUserFilterInput>;
  activeUserId?: InputMaybe<IntOperationFilterInput>;
  and?: InputMaybe<Array<JeopardyRoundFilterInput>>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  game?: InputMaybe<JeopardyGameFilterInput>;
  gameId?: InputMaybe<IntOperationFilterInput>;
  jeopardyUserAnswers?: InputMaybe<ListFilterInputTypeOfJeopardyUserAnswerFilterInput>;
  or?: InputMaybe<Array<JeopardyRoundFilterInput>>;
  question?: InputMaybe<JeopardyQuestionFilterInput>;
  questionId?: InputMaybe<IntOperationFilterInput>;
  remainingAnswerTime?: InputMaybe<IntOperationFilterInput>;
  roundId?: InputMaybe<IntOperationFilterInput>;
  roundNumber?: InputMaybe<IntOperationFilterInput>;
  timeEnd?: InputMaybe<DateTimeOperationFilterInput>;
  timeStart?: InputMaybe<DateTimeOperationFilterInput>;
};

export type JeopardyRoundSortInput = {
  activeUser?: InputMaybe<JeopardyUserSortInput>;
  activeUserId?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  game?: InputMaybe<JeopardyGameSortInput>;
  gameId?: InputMaybe<SortEnumType>;
  question?: InputMaybe<JeopardyQuestionSortInput>;
  questionId?: InputMaybe<SortEnumType>;
  remainingAnswerTime?: InputMaybe<SortEnumType>;
  roundId?: InputMaybe<SortEnumType>;
  roundNumber?: InputMaybe<SortEnumType>;
  timeEnd?: InputMaybe<SortEnumType>;
  timeStart?: InputMaybe<SortEnumType>;
};

export type JeopardyUser = {
  __typename?: 'JeopardyUser';
  avatar?: Maybe<Scalars['String']['output']>;
  connected: Scalars['Boolean']['output'];
  createdOn?: Maybe<Scalars['DateTime']['output']>;
  deviceDetected?: Maybe<Scalars['String']['output']>;
  deviceIdentifier?: Maybe<Scalars['String']['output']>;
  game?: Maybe<JeopardyGame>;
  gameId: Scalars['Int']['output'];
  host: Scalars['Boolean']['output'];
  jeopardyRounds?: Maybe<Array<Maybe<JeopardyRound>>>;
  jeopardyUserAnswers?: Maybe<Array<Maybe<JeopardyUserAnswer>>>;
  jokerFiftyFifty?: Maybe<Scalars['Int']['output']>;
  jokerSkip?: Maybe<Scalars['Int']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  playInactivityCounter?: Maybe<Scalars['Int']['output']>;
  playOrder?: Maybe<Scalars['Int']['output']>;
  playingTime?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  userId: Scalars['Int']['output'];
};

export type JeopardyUserAnswer = {
  __typename?: 'JeopardyUserAnswer';
  createdOn?: Maybe<Scalars['DateTime']['output']>;
  points?: Maybe<Scalars['Int']['output']>;
  round?: Maybe<JeopardyRound>;
  roundId: Scalars['Int']['output'];
  selectedAnswerIndex?: Maybe<Scalars['Int']['output']>;
  skip: Scalars['Boolean']['output'];
  trueAnswerIndex: Scalars['Int']['output'];
  user?: Maybe<JeopardyUser>;
  userAnswerId: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type JeopardyUserAnswerFilterInput = {
  and?: InputMaybe<Array<JeopardyUserAnswerFilterInput>>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<JeopardyUserAnswerFilterInput>>;
  points?: InputMaybe<IntOperationFilterInput>;
  round?: InputMaybe<JeopardyRoundFilterInput>;
  roundId?: InputMaybe<IntOperationFilterInput>;
  selectedAnswerIndex?: InputMaybe<IntOperationFilterInput>;
  skip?: InputMaybe<BooleanOperationFilterInput>;
  trueAnswerIndex?: InputMaybe<IntOperationFilterInput>;
  user?: InputMaybe<JeopardyUserFilterInput>;
  userAnswerId?: InputMaybe<IntOperationFilterInput>;
  userId?: InputMaybe<IntOperationFilterInput>;
};

export type JeopardyUserAnswerSortInput = {
  createdOn?: InputMaybe<SortEnumType>;
  points?: InputMaybe<SortEnumType>;
  round?: InputMaybe<JeopardyRoundSortInput>;
  roundId?: InputMaybe<SortEnumType>;
  selectedAnswerIndex?: InputMaybe<SortEnumType>;
  skip?: InputMaybe<SortEnumType>;
  trueAnswerIndex?: InputMaybe<SortEnumType>;
  user?: InputMaybe<JeopardyUserSortInput>;
  userAnswerId?: InputMaybe<SortEnumType>;
  userId?: InputMaybe<SortEnumType>;
};

export type JeopardyUserFilterInput = {
  and?: InputMaybe<Array<JeopardyUserFilterInput>>;
  avatar?: InputMaybe<StringOperationFilterInput>;
  connected?: InputMaybe<BooleanOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  deviceDetected?: InputMaybe<StringOperationFilterInput>;
  deviceIdentifier?: InputMaybe<StringOperationFilterInput>;
  game?: InputMaybe<JeopardyGameFilterInput>;
  gameId?: InputMaybe<IntOperationFilterInput>;
  host?: InputMaybe<BooleanOperationFilterInput>;
  jeopardyRounds?: InputMaybe<ListFilterInputTypeOfJeopardyRoundFilterInput>;
  jeopardyUserAnswers?: InputMaybe<ListFilterInputTypeOfJeopardyUserAnswerFilterInput>;
  jokerFiftyFifty?: InputMaybe<IntOperationFilterInput>;
  jokerSkip?: InputMaybe<IntOperationFilterInput>;
  language?: InputMaybe<StringOperationFilterInput>;
  location?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<JeopardyUserFilterInput>>;
  playInactivityCounter?: InputMaybe<IntOperationFilterInput>;
  playOrder?: InputMaybe<IntOperationFilterInput>;
  playingTime?: InputMaybe<IntOperationFilterInput>;
  score?: InputMaybe<IntOperationFilterInput>;
  userId?: InputMaybe<IntOperationFilterInput>;
};

export type JeopardyUserSortInput = {
  avatar?: InputMaybe<SortEnumType>;
  connected?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  deviceDetected?: InputMaybe<SortEnumType>;
  deviceIdentifier?: InputMaybe<SortEnumType>;
  game?: InputMaybe<JeopardyGameSortInput>;
  gameId?: InputMaybe<SortEnumType>;
  host?: InputMaybe<SortEnumType>;
  jokerFiftyFifty?: InputMaybe<SortEnumType>;
  jokerSkip?: InputMaybe<SortEnumType>;
  language?: InputMaybe<SortEnumType>;
  location?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  playInactivityCounter?: InputMaybe<SortEnumType>;
  playOrder?: InputMaybe<SortEnumType>;
  playingTime?: InputMaybe<SortEnumType>;
  score?: InputMaybe<SortEnumType>;
  userId?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type JeopardyUsersConnection = {
  __typename?: 'JeopardyUsersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<JeopardyUsersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<JeopardyUser>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type JeopardyUsersEdge = {
  __typename?: 'JeopardyUsersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<JeopardyUser>;
};

export type ListFilterInputTypeOfJeopardyGameFilterInput = {
  all?: InputMaybe<JeopardyGameFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<JeopardyGameFilterInput>;
  some?: InputMaybe<JeopardyGameFilterInput>;
};

export type ListFilterInputTypeOfJeopardyQuestionFilterInput = {
  all?: InputMaybe<JeopardyQuestionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<JeopardyQuestionFilterInput>;
  some?: InputMaybe<JeopardyQuestionFilterInput>;
};

export type ListFilterInputTypeOfJeopardyRoundFilterInput = {
  all?: InputMaybe<JeopardyRoundFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<JeopardyRoundFilterInput>;
  some?: InputMaybe<JeopardyRoundFilterInput>;
};

export type ListFilterInputTypeOfJeopardyUserAnswerFilterInput = {
  all?: InputMaybe<JeopardyUserAnswerFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<JeopardyUserAnswerFilterInput>;
  some?: InputMaybe<JeopardyUserAnswerFilterInput>;
};

export type ListFilterInputTypeOfJeopardyUserFilterInput = {
  all?: InputMaybe<JeopardyUserFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<JeopardyUserFilterInput>;
  some?: InputMaybe<JeopardyUserFilterInput>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** The active player selected a question */
  chooseQuestionPoints?: Maybe<PayloadEntityOfJeopardyRound>;
  /** Allows to start a new game. */
  createJeopardyGame?: Maybe<PayloadEntityOfJeopardyGame>;
  /** Allows an opponent player to join a room for the first time */
  joinRoom?: Maybe<PayloadEntityOfJeopardyUser>;
  /** Allows a player to reconnect to the ongoing game */
  joinRoomAgain?: Maybe<PayloadEntityOfJeopardyUser>;
  /** Allows a player to answer a question */
  provideAnswerToQuestion?: Maybe<PayloadEntityOfJeopardyUserAnswer>;
  /** Allows to update a user. */
  updateJeopardyUser?: Maybe<PayloadEntityOfJeopardyUser>;
};


export type MutationChooseQuestionPointsArgs = {
  gameId: Scalars['Int']['input'];
  questionId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationCreateJeopardyGameArgs = {
  input?: InputMaybe<AddJeopardyGameInput>;
};


export type MutationJoinRoomArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  gameId: Scalars['Int']['input'];
  lang?: InputMaybe<Scalars['String']['input']>;
};


export type MutationJoinRoomAgainArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  gameId: Scalars['Int']['input'];
  lang?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['Int']['input'];
};


export type MutationProvideAnswerToQuestionArgs = {
  gameId: Scalars['Int']['input'];
  input?: InputMaybe<AddJeopardyUserAnswerInput>;
};


export type MutationUpdateJeopardyUserArgs = {
  input?: InputMaybe<UpdateJeopardyUserInput>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** Indicates whether more edges exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean']['output'];
  /** Indicates whether more edges exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PayloadEntityOfJeopardyGame = {
  __typename?: 'PayloadEntityOfJeopardyGame';
  entity?: Maybe<JeopardyGame>;
  errors?: Maybe<Array<Maybe<JeopardyApiCoreError>>>;
  warnings?: Maybe<Array<Maybe<JeopardyApiCoreWarning>>>;
};

export type PayloadEntityOfJeopardyRound = {
  __typename?: 'PayloadEntityOfJeopardyRound';
  entity?: Maybe<JeopardyRound>;
  errors?: Maybe<Array<Maybe<JeopardyApiCoreError>>>;
  warnings?: Maybe<Array<Maybe<JeopardyApiCoreWarning>>>;
};

export type PayloadEntityOfJeopardyUser = {
  __typename?: 'PayloadEntityOfJeopardyUser';
  entity?: Maybe<JeopardyUser>;
  errors?: Maybe<Array<Maybe<JeopardyApiCoreError>>>;
  warnings?: Maybe<Array<Maybe<JeopardyApiCoreWarning>>>;
};

export type PayloadEntityOfJeopardyUserAnswer = {
  __typename?: 'PayloadEntityOfJeopardyUserAnswer';
  entity?: Maybe<JeopardyUserAnswer>;
  errors?: Maybe<Array<Maybe<JeopardyApiCoreError>>>;
  warnings?: Maybe<Array<Maybe<JeopardyApiCoreWarning>>>;
};

export type Query = {
  __typename?: 'Query';
  /** Represents the list of active game. */
  jeopardyActiveGames?: Maybe<Array<Maybe<JeopardyGame>>>;
  /** Represents the current round of a specific gameID. */
  jeopardyCurrentRoundByGameId?: Maybe<JeopardyRound>;
  /** Allows to retrieve a specific game by its ID. */
  jeopardyGameById?: Maybe<JeopardyGame>;
  /** Allows to retrieve a specific question by its ID. */
  jeopardyQuestionById?: Maybe<JeopardyQuestion>;
  /** Represents the list of all questions by gameID. */
  jeopardyQuestionsByGameId?: Maybe<Array<Maybe<JeopardyQuestion>>>;
  /** Represents the list of rooms name that can be used for creating a new game. */
  jeopardyRooms?: Maybe<Array<Maybe<JeopardyRoom>>>;
  /** Represents the list of all rounds by gameID. */
  jeopardyRoundsByGameId?: Maybe<Array<Maybe<JeopardyRound>>>;
  /** Allows to retrieve a specific UserAnswer by its ID. */
  jeopardyUserAnswerById?: Maybe<JeopardyUserAnswer>;
  /** Represents the list of all UserAnswers by userID. */
  jeopardyUserAnswersByUserId?: Maybe<Array<Maybe<JeopardyUserAnswer>>>;
  /** Allows to retrieve a specific user by its ID. */
  jeopardyUserById?: Maybe<JeopardyUser>;
  /** Represents the list of all users. Can be filtered. Used for General ranking */
  jeopardyUsers?: Maybe<JeopardyUsersConnection>;
  /** Represents the list of all users by gameID. */
  jeopardyUsersByGameId?: Maybe<Array<Maybe<JeopardyUser>>>;
};


export type QueryJeopardyActiveGamesArgs = {
  order?: InputMaybe<Array<JeopardyGameSortInput>>;
  where?: InputMaybe<JeopardyGameFilterInput>;
};


export type QueryJeopardyCurrentRoundByGameIdArgs = {
  gameId: Scalars['Int']['input'];
};


export type QueryJeopardyGameByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryJeopardyQuestionByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryJeopardyQuestionsByGameIdArgs = {
  gameId: Scalars['Int']['input'];
  order?: InputMaybe<Array<JeopardyQuestionSortInput>>;
  where?: InputMaybe<JeopardyQuestionFilterInput>;
};


export type QueryJeopardyRoomsArgs = {
  order?: InputMaybe<Array<JeopardyRoomSortInput>>;
  where?: InputMaybe<JeopardyRoomFilterInput>;
};


export type QueryJeopardyRoundsByGameIdArgs = {
  gameId: Scalars['Int']['input'];
  order?: InputMaybe<Array<JeopardyRoundSortInput>>;
  where?: InputMaybe<JeopardyRoundFilterInput>;
};


export type QueryJeopardyUserAnswerByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryJeopardyUserAnswersByUserIdArgs = {
  order?: InputMaybe<Array<JeopardyUserAnswerSortInput>>;
  userId: Scalars['Int']['input'];
  where?: InputMaybe<JeopardyUserAnswerFilterInput>;
};


export type QueryJeopardyUserByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryJeopardyUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<JeopardyUserSortInput>>;
  where?: InputMaybe<JeopardyUserFilterInput>;
};


export type QueryJeopardyUsersByGameIdArgs = {
  gameId: Scalars['Int']['input'];
};

export enum SortEnumType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StringOperationFilterInput = {
  and?: InputMaybe<Array<StringOperationFilterInput>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ncontains?: InputMaybe<Scalars['String']['input']>;
  nendsWith?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nstartsWith?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<StringOperationFilterInput>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  beforeRoundStart?: Maybe<JeopardyRound>;
  jeopardyGameInactivated?: Maybe<JeopardyGame>;
  jeopardyUserConnected?: Maybe<JeopardyUser>;
  jeopardyUserDisconnected?: Maybe<JeopardyUser>;
  jeopardyUserIdleDetected?: Maybe<JeopardyUser>;
  roundEnded?: Maybe<JeopardyRound>;
  roundStarted?: Maybe<JeopardyRound>;
  userScoreUpdated?: Maybe<JeopardyUser>;
};


export type SubscriptionBeforeRoundStartArgs = {
  gameId: Scalars['Int']['input'];
};


export type SubscriptionJeopardyGameInactivatedArgs = {
  gameId: Scalars['Int']['input'];
};


export type SubscriptionJeopardyUserConnectedArgs = {
  gameId: Scalars['Int']['input'];
};


export type SubscriptionJeopardyUserDisconnectedArgs = {
  gameId: Scalars['Int']['input'];
};


export type SubscriptionJeopardyUserIdleDetectedArgs = {
  gameId: Scalars['Int']['input'];
};


export type SubscriptionRoundEndedArgs = {
  gameId: Scalars['Int']['input'];
};


export type SubscriptionRoundStartedArgs = {
  gameId: Scalars['Int']['input'];
};


export type SubscriptionUserScoreUpdatedArgs = {
  gameId: Scalars['Int']['input'];
};

/** Represents an updated user. */
export type UpdateJeopardyUserInput = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  connected: Scalars['Boolean']['input'];
  deviceDetected?: InputMaybe<Scalars['String']['input']>;
  deviceIdentifier?: InputMaybe<Scalars['String']['input']>;
  host: Scalars['Boolean']['input'];
  jokerFiftyFifty?: InputMaybe<Scalars['Int']['input']>;
  jokerSkip?: InputMaybe<Scalars['Int']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  playInactivityCounter?: InputMaybe<Scalars['Int']['input']>;
  playingTime?: InputMaybe<Scalars['Int']['input']>;
  score?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['Int']['input'];
};

export type UuidOperationFilterInput = {
  eq?: InputMaybe<Scalars['UUID']['input']>;
  gt?: InputMaybe<Scalars['UUID']['input']>;
  gte?: InputMaybe<Scalars['UUID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  lt?: InputMaybe<Scalars['UUID']['input']>;
  lte?: InputMaybe<Scalars['UUID']['input']>;
  neq?: InputMaybe<Scalars['UUID']['input']>;
  ngt?: InputMaybe<Scalars['UUID']['input']>;
  ngte?: InputMaybe<Scalars['UUID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  nlt?: InputMaybe<Scalars['UUID']['input']>;
  nlte?: InputMaybe<Scalars['UUID']['input']>;
};
